module.exports = __webpack_public_path__ + "img/brain.b64d5048.svg";